import { useMutation, useQuery, useQueryClient } from 'react-query';
import { baseURL } from 'Types/APITypes';
import { CommercialERSInformation } from 'components/CommercialERS/CommercialERSInformationFields';
import { MaestroAPI, maestroApiCall } from '@michelin/central-provider';
import { QueryKeys } from 'Types';
import GLOBAL_CONFIG from '../global-variables';

const getCommercialERSInformation = (stNumber: string) => maestroApiCall(
  { method: 'GET', endpoint: `locations/${stNumber}/commercial-location/ers-information`, baseURL },
);

export default function useCommercialERSInformationQuery(stNumber: string) {
  return useQuery<CommercialERSInformation>([QueryKeys.commercialERSInformation, stNumber], () => getCommercialERSInformation(stNumber));
}

interface saveParams {
  stNumber: string,
  data: CommercialERSInformation
}

async function saveCommercialERSInformation({ stNumber, data }: saveParams) {
  const apiType: MaestroAPI = { method: 'PUT', endpoint: `locations/${stNumber}/commercial-location/ers-information`, baseURL };
  const newData: CommercialERSInformation = data;

  if (newData.ers_tire_services.do_you_have_trucks && newData.ers_tire_services.number_of_trucks) {
    newData.ers_tire_services.number_of_trucks = parseInt(data.ers_tire_services.number_of_trucks.toString(), 10);
  }

  if (newData.ers_mechanical_services.do_you_have_trucks && newData.ers_mechanical_services.number_of_trucks) {
    newData.ers_mechanical_services.number_of_trucks = parseInt(data.ers_mechanical_services.number_of_trucks.toString(), 10);
  }

  const res = await maestroApiCall(apiType, newData);
  return res;
}

export function useSaveCommercialERSInformation(stNumber: string) {
  const queryClient = useQueryClient();
  return useMutation(saveCommercialERSInformation, {
    onSuccess: () => {
      queryClient.invalidateQueries([QueryKeys.commercialERSInformation, stNumber]);
    },
  });
}

interface DtmfTestParams {
  destinationNumber: string;
  dtmfConfiguration?: string;
  initialWaitPeriodMs?: number;
}

async function initiateDtmfTest(params: DtmfTestParams) {
  const apiType: MaestroAPI = {
    method: 'POST',
    endpoint: 'initiate-dtmf-test',
    baseURL: GLOBAL_CONFIG.oncallAPIUrl,
  };
  const body: Record<string, unknown> = {
    outboundCallType: 'DTMF_TEST_CALL',
    destinationNumber: params.destinationNumber,
  };
  if (params.dtmfConfiguration) {
    body.dtmfConfiguration = params.dtmfConfiguration;
  }
  if (params.initialWaitPeriodMs && params.initialWaitPeriodMs > 0) {
    body.initialWaitPeriodMs = params.initialWaitPeriodMs;
  }
  return maestroApiCall(apiType, body);
}

export function useInitiateDtmfTest() {
  return useMutation(initiateDtmfTest);
}
